(() => {
  if (window.__wbpParallaxInitialised) return;
  window.__wbpParallaxInitialised = true;

  const selector = 'slideshow-component[data-wbp-parallax="true"]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let components = [];
  let framePending = false;

  const collect = () => {
    components = Array.from(document.querySelectorAll(selector));
  };

  const reset = () => {
    components.forEach((component) => {
      component.style.setProperty('--wbp-parallax-y', '0px');
    });
  };

  const render = () => {
    framePending = false;

    if (reducedMotion.matches) {
      reset();
      return;
    }

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    components.forEach((component) => {
      const rect = component.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      let offset;

      if (window.innerWidth >= 750) {
        const documentTop = window.scrollY + rect.top;
        const maxOffset = Math.min(rect.height * 0.135, 105);
        offset = Math.max(-maxOffset, Math.min(maxOffset, (window.scrollY - documentTop) * 0.22));
      } else {
        const strength = Number(component.dataset.wbpParallaxStrength) || 75;
        const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
        const normalized = Math.max(-1, Math.min(1, (progress - 0.5) * 2));
        offset = normalized * strength * 0.35;
      }

      component.style.setProperty('--wbp-parallax-y', offset.toFixed(2) + 'px');
    });
  };

  const schedule = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(render);
  };

  collect();
  schedule();

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reducedMotion.addEventListener?.('change', schedule);

  document.addEventListener('shopify:section:load', () => {
    collect();
    schedule();
  });
})();
